import React from 'react';
import PropTypes from 'prop-types';
import Channel from './Channel';
import SongStore from '../stores/SongStore';
import MasterChannel from './MasterChannel';

export default class ChannelGrid extends React.Component {

	static contextTypes = {
		executeAction: PropTypes.func.isRequired,
		getStore: PropTypes.func.isRequired
	};

	constructor(props, context) {
		super(props, context);

		var store = context.getStore(SongStore);

		this.state = {
			selected : store.getSeleted()
		};

		store.on("SELECTED_SEQUENCE_CHANGE", () => {
			this.setState({
				selected : store.getSeleted()
			});
		});

	}

	render() {

		var channels = [], channelProps;

		for (var i = 0; i < 7; i++) {
			channelProps = {
				number: i,
				key: i,
				selected: this.state.selected.channel == i
			}
			if(channelProps.selected) {
				channelProps.selectedSequence = this.state.selected.sequence
			}
			channels.push(<Channel {...channelProps}/>)
		}

		var master = <MasterChannel/>

		return (
			<div className="ChannelGrid">
				{channels}
				{master}
			</div>
		);
	}
}
